import {
  USER_CARDS_LOADING,
  USER_CARDS_LOADED,
  USER_CARDS_ERROR,
  SET_CURRENT_CARD,
  CLEAR_CURRENT_CARD,
  CARD_LOADED,
  USER_ORDERS_LOADING,
  USER_ORDERS_LOADED,
  USER_ORDERS_ERROR,
  RECHARGE_CARDS_LOADING,
  RECHARGE_CARDS_LOADED,
  RECHARGE_CARDS_ERROR,
  RESET_CARD,
  SET_CURRENT_ORDER,
  SET_CURRENT_CONTRACT,
  CLEAR_CURRENT_CONTRACT,
  CHECK_SUBSCRIPTION_ALLOWED,
  ORDER_SUBMIT_SUCCESS,
} from "../types";

//eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case RESET_CARD:
      return {
        ...state,
        ...action.payload,
      };
    case USER_CARDS_LOADING:
      return { ...state, isLoading: true, loaded: false, error: null };
    case USER_ORDERS_LOADING:
      return { ...state, orderLoading: true, orderLoaded: false, error: null };
    case RECHARGE_CARDS_LOADING:
      return {
        ...state,
        rechargeLoading: true,
        rechargeLoaded: false,
        error: null,
      };
    case USER_CARDS_LOADED:
      return {
        ...state,
        cards: action.payload,
        isLoading: false,
        loaded: true,
      };
    case ORDER_SUBMIT_SUCCESS:
      return {
        ...state,
        completedOrder: action.payload,
        orderLoading: false,
      };
    case SET_CURRENT_ORDER:
      localStorage.setItem("selectedOrder", JSON.stringify(action.payload));
      return {
        ...state,
        selectedOrder: action.payload,
        orderLoading: false,
      };
    case CARD_LOADED:
      return {
        ...state,
        selectedCard: action.payload,
        isLoading: false,
        loaded: true,
      };
    case USER_ORDERS_LOADED:
      return {
        ...state,
        orders: action.payload,
        orderLoading: false,
        orderLoaded: true,
      };
    case RECHARGE_CARDS_LOADED:
      return {
        ...state,
        rechargeCards: action.payload,
        rechargeLoading: false,
        rechargeLoaded: true,
        changedCards: action.payload.data,
      };
    case USER_CARDS_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        loaded: false,
      };
    case USER_ORDERS_ERROR:
      return {
        ...state,
        error: action.payload,
        orderLoading: false,
        orderLoaded: false,
      };
    case RECHARGE_CARDS_ERROR:
      return {
        ...state,
        error: action.payload,
        rechargeLoading: false,
        rechargeLoaded: false,
      };
    case SET_CURRENT_CARD:
      return { ...state, selectedCard: action.payload.card };
    case CLEAR_CURRENT_CARD:
      return { ...state, selectedCard: null };
    case SET_CURRENT_CONTRACT:
      localStorage.setItem("selectedContract", JSON.stringify(action.payload));
      return {
        ...state,
        selectedContract: action.payload,
        isLoading: false,
        loaded: true,
      };
    case CHECK_SUBSCRIPTION_ALLOWED:
      return {
        ...state,
        isSubscriptionAllowed: action.payload.card,
        isLoading: false,
        loaded: true,
      };
    case CLEAR_CURRENT_CONTRACT:
      localStorage.removeItem("selectedContract");
      return { ...state, selectedContract: null };
    default:
      return state;
  }
};
